import { Card, Text, Image } from '@/ui'
import { useEffect } from 'react'
import { useAnalyticsView } from '@/features/amplitude'
import { TypographyStyles } from '@/styles'

export const PlaidIntroPage = () => {
  const pageView = useAnalyticsView()

  useEffect(() => {
    pageView('statements splash')
  }, [pageView])
  return (
    <div className="flex flex-col lg:flex-row gap-6 mt-4">
      <div className="w-full lg:w-1/3">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/green-check.png"
          alt="Confirmation checkmark"
          className="bg-moss-25 p-20"
        />
      </div>

      <div className="w-full lg:w-2/3 space-y-4">
        <Text variant={TypographyStyles.H2}>We have your bank statements</Text>
        <Text>
          Because you gave us access to your statements via Plaid, there&apos;s
          no need for you to upload them now or in the future.
        </Text>

        <Card className="bg-stone p-4">
          <Text className="font-semibold">Why does Heard need these?</Text>
          <Text>
            We need your statements to reconcile your books, a standard
            procedure to ensure completeness and accuracy. In the future, you
            will only need to upload statements if there&apos;s a Plaid
            connection error.
          </Text>
        </Card>
      </div>
    </div>
  )
}
